module.exports = __webpack_public_path__ + "img/profpic2.c070b35e.jpg";